export default __webpack_public_path__ + "static/media/userj.2690e7e1.jpg";